import TechnicalOverlay from './TechnicalOverlay';

export default TechnicalOverlay;
